import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { API, fmtErr } from "../lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords do not match");
    setBusy(true);
    setError("");
    try {
      await API.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md space-y-6 rounded-lg border bg-card p-8">
        <div>
          <p className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-primary">ADS Billing</p>
          <h1 className="mt-2 font-heading text-2xl font-bold tracking-tight">Set a new password</h1>
        </div>
        {!token ? (
          <p className="text-sm text-destructive" data-testid="reset-error">Invalid reset link. Request a new one from the sign-in page.</p>
        ) : done ? (
          <div className="space-y-4">
            <p className="text-sm text-[#008A52]" data-testid="reset-success-message">Password updated. You can sign in with your new password now.</p>
            <Button className="w-full" onClick={() => navigate("/login")} data-testid="reset-goto-login-button">Go to Sign In</Button>
          </div>
        ) : (
          <form className="space-y-4" onSubmit={submit}>
            <div className="space-y-2">
              <Label htmlFor="reset-password">New Password</Label>
              <Input id="reset-password" data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="reset-confirm">Confirm Password</Label>
              <Input id="reset-confirm" data-testid="reset-confirm-input" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat password" />
            </div>
            {error && <p className="text-sm font-medium text-destructive" data-testid="reset-error">{error}</p>}
            <Button type="submit" className="w-full" disabled={busy} data-testid="reset-submit-button">
              {busy ? "Updating…" : "Update Password"}
            </Button>
          </form>
        )}
        <p className="text-center text-sm text-muted-foreground">
          <Link to="/login" className="font-medium text-primary hover:underline" data-testid="reset-back-to-login-link">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
